// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scrolling[data-v-1897c5e8]{box-shadow:0 8px 24px rgba(149,157,165,.2)!important}", ""]);
// Exports
module.exports = exports;
